import extend from '@/utils/vuex-extend';
import {dialog} from '@/vuex-extend';
import {
	getOrderDetail,
	getOrderDetailByOrderSn,
	printDeliveryorder,
	saveOrderWeight,
	orderReceived, remark, orderRemark, confirmPackage, updateGoodsNum, rematch, outDelivery
} from '@/api/sms/forwarding-order';
import {wait} from '@/utils/wait';
import {Message} from 'element-ui';

export default extend(dialog, {
	namespaced: true,
	state: {
		id: 0,
		orderSn: 0,
		type: 'id',
		detail: {},
		form: {},
	},
	actions: {
		async afterOpenDialog({dispatch, commit, state}, payload) {
			const {id, orderSn, type, platformType} = state;
			console.log("afterOpenDialog" + id);
			localStorage.setItem("deliver.detail.open", 1);
			await wait(dispatch, 'sms.forwarding-order.detail', async function () {
				let response = null;
				if (type === 'orderSn') {
					response = await getOrderDetailByOrderSn({orderSn: orderSn, platformType: platformType});
				} else {
					response = await getOrderDetail(id);
				}
				if (response.data) {
					commit('save', {
						detail: response.data,
						form: {
							cartonNumber: response.data.cartonNumber,
							packageWeight: response.data.costFreight ? response.data.costFreight.expressWeight : null,
							gaugeL: response.data.costFreight ? response.data.costFreight.expressGuageLength : null,
							gaugeW: response.data.costFreight ? response.data.costFreight.expressGuageWidth : null,
							gaugeH: response.data.costFreight ? response.data.costFreight.expressGuageHeight : null,
							expressUnitPrice: response.data.costFreight ? response.data.costFreight.expressBaseUnitPrice : null,
							farawayUnitPrice: response.data.costFreight ? response.data.costFreight.expressFarawayUnitPrice : null,
							privateAddressUnitPrice: response.data.costFreight ? response.data.costFreight.expressPrivateAddressUnitPrice : null,
							otherPrice: response.data.costFreight ? response.data.costFreight.expressOtherPrice : null,
							operatePrice: response.data.costFreight ? response.data.costFreight.expressOperatePrice : null,
							expressCompany: response.data.costFreight ? response.data.costFreight.courier : null,
							forwarder: response.data.costFreight ? response.data.costFreight.forwarder : null,
							invoiceNumber: response.data.invoiceNumber,
							trackingNo: response.data.trackingNo,
							expectedDeliveryDate: response.data.expectedDeliveryDate,
							expectedReceiptDate: response.data.agent ? response.data.agent.receiptDate : null,
							discountAmount: response.data.discountAmount,
							remark: response.data.remark,
							orderAmount: response.data.orderAmount
						},
					})
				} else {
					Message.error({
						message: '无此订单',
						onClose: () => {
							dispatch('closeDialog')
						}
					})
				}
			})
		},
		async confirm({dispatch, commit, state}, payload) {
			const {detail, form} = state;
			await wait(dispatch, 'sms.forwarding-order.confirm', async function () {
				const response = await saveOrderWeight({
					orderSn: detail.orderSn,
					...form
				});
				if (response.data) {
					Message.success('保存成功');
					dispatch('closeDialog');
					dispatch('smsForwardingOrder/getList', {}, {root: true});
				}
			})
		},
		async remark({dispatch, commit, state}, payload) {
			const {detail, form} = state;
			await wait(dispatch, 'sms.forwarding-order.remark', async function () {
				const response = await orderRemark({
					orderSn: detail.orderSn,
					remark: form.remark
				});
				if (response.data) {
					Message.success('保存成功');
					dispatch('afterOpenDialog');
				}
			})
		},

		async changePackage({dispatch, commit, state}, payload) {
			await wait(dispatch, 'sms.forwarding-order.package', async function () {
				const response = await confirmPackage(payload);
				if (response.data) {
					Message.success('Confirm Pacakge Success');
				}
			})
		},

		async updateGoodsNum({dispatch, commit, state}, payload) {
			await wait(dispatch, 'sms.forwarding-order.update.goodsNum', async function () {
				const response = await updateGoodsNum(payload);
				if(response.data){
					dispatch('afterOpenDialog');
				}
			})
		},

		async rematch({dispatch, commit, state}, payload) {
			await wait(dispatch, 'sms.forwarding-order.rematch', async function () {
				const response = await rematch(payload);
				if(response.data){
					Message.success('美国仓重新配货成功');
					dispatch('closeDialog');
					dispatch('smsForwardingOrder/getList', {}, {root: true});
				}
			})
		},

		async outDelivery({dispatch, commit, state}, payload) {
			await wait(dispatch, 'sms.forwarding-order.outDelivery', async function () {
				const response = await outDelivery(payload);
				if(response.data){
					Message.success('平台订单转远期单成功');
					dispatch('closeDialog');
					dispatch('smsForwardingOrder/getList', {}, {root: true});
				}
			})
		},

		async printDeliveryorder({dispatch, commit, state}, payload) {
			await wait(dispatch, `sms.forwarding-order.createPrint`, async function () {
				const response = await printDeliveryorder(payload);
				if (response.data) {
					if (response.data.indexOf("http") === 0) {
						window.open(response.data)
					} else {
						dispatch('closeDialog');
						dispatch('smsForwardingOrderList/getList', {}, {root: true});
					}
				}
			})
		},
		// // 到仓签收
		// async getScanning({ state, dispatch }, payload) {
		// 	await wait(dispatch, `sms.scanning.list`, async function () {
		// 		const response = await orderReceived(payload);
		// 		console.log(response)
		// 		if (response.data) {
		// 			console.log(response.data)
		// 		}
		// 	})
		// },
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/sms/forwarding-order/detail.js